module.exports = __webpack_public_path__ + "static/img/enterprise-4.115ff968.png";